import React, { useEffect } from 'react';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';

const LocationSearch = ({ formik, fieldName = 'address' }) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      location: { lat: () => 28.7041, lng: () => 77.1025 },
      radius: 100 * 1000,
    },
    debounce: 300,
  });

  // Sync with formik value when it changes (including on edit load)
  useEffect(() => {
    const formikValue = formik.values[fieldName];
    if (formikValue && formikValue !== value) {
      setValue(formikValue, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values[fieldName]]);

  const handleInput = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    formik.setFieldValue(fieldName, inputValue);
    
    // Clear coordinates if user manually types
    if (!inputValue) {
      formik.setFieldValue('coordinates', []);
    }
  };

  const handleSelect = async (description) => {
    setValue(description, false);
    clearSuggestions();

    try {
      const results = await getGeocode({ address: description });
      const { lat, lng } = await getLatLng(results[0]);
      
      // IMPORTANT: Send as [lng, lat] (longitude first, latitude second)
      formik.setFieldValue(fieldName, description);
      formik.setFieldValue('coordinates', [lng, lat]);
      
      console.log('Selected Location:', {
        address: description,
        coordinates: [lng, lat], // [longitude, latitude]
        lng,
        lat
      });
      
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  return (
    <div className="location-search-wrapper" style={{ position: 'relative' }}>
      <input
        type="text"
        className="form-control"
        value={value}
        onChange={handleInput}
        onBlur={(e) => {
          formik.handleBlur(e);
          setTimeout(() => clearSuggestions(), 200);
        }}
        disabled={!ready}
        placeholder="Search for a location"
        name={fieldName}
        autoComplete="off"
      />

      {status === "OK" && data.length > 0 && (
        <ul 
          className="list-group location-suggestions"
          style={{
            position: 'absolute',
            zIndex: 1000,
            width: '100%',
            maxHeight: '200px',
            overflowY: 'auto',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            marginTop: '2px',
            borderRadius: '4px'
          }}
        >
          {data.map(({ place_id, description }) => (
            <li
              key={place_id}
              className="list-group-item list-group-item-action"
              onClick={() => handleSelect(description)}
              style={{ 
                cursor: 'pointer',
                padding: '10px 15px'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
            >
              <i className="fa-solid fa-location-dot me-2" style={{ color: '#666' }}></i>
              {description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LocationSearch;